module.exports = __webpack_public_path__ + "files/a9ff4f8c1d623db5caa75f593b34a8c8.png";